import type { StudentSpecificContextualDataEntry } from '@mission.io/mission-toolkit'

import { useJuniorPlusStateSelector } from '../context/customHooks'
import { useMaps } from '../context/provider'
import { type Map, getContextualData } from '@mission.io/mission-toolkit'

/**
 * Gets all contextual data associated with the canvasActionId that is relevant to the team with the given `teamId`
 */
export function useTeamDataForCreativeCanvas(
	canvasActionId: string,
	teamId: string
): Array<StudentSpecificContextualDataEntry> {
	const maps = useMaps()

	return useContextualData(
		{ type: 'CREATIVE_CANVAS', canvasActionId, maps },
		{ teamId }
	)
}

/**
 * gets the contextual data for the given context for the current student
 */
export function useContextualData(
	context:
		| {|
				type: 'MAP',
				map: Map | void | null,
				includeHiddenObjects?: boolean,
				includeUnscannedObjects?: boolean,
		  |}
		| {|
				type: 'CREATIVE_CANVAS',
				canvasActionId: string,
				maps: Array<Map>,
		  |},
	entity: {| teamId: string |}
): Array<StudentSpecificContextualDataEntry> {
	const { base, extra } = useJuniorPlusStateSelector(state => {
		if (!state) {
			return { base: [], extra: [] }
		}
		if (context.type === 'MAP') {
			const map = context.map
			if (!map) {
				return { base: [], extra: [] }
			}
			return getContextualData(state, { ...context, map }, entity)
		}
		return getContextualData(state, context, entity)
	})

	return [...base, ...extra]
}
